module.exports = __webpack_public_path__ + "media/bootstrap-icons/images-7a24158e.svg";